import React from 'react';
import Logo from '../../../Components/UIElements/Logo';
import SectionWrapper, { ImageSlider, ImageSlide } from './clientBlock.style';

import { clients } from '../../../assets/data';

const ClientBlock = () => {
  return (
    <SectionWrapper>
      <ImageSlider>
        <ImageSlide>
          {clients.map(item => (
            <Logo
              key={`slide1__key${item.id}`}
              href={item.link}
              target="_blank"
              logoSrc={item.logo}
              title={item.name}
            />
          ))}
        </ImageSlide>
        <ImageSlide>
          {clients.map(item => (
            <Logo
              key={`slide2__key${item.id}`}
              href={item.link}
              target="_blank"
              logoSrc={item.logo}
              title={item.name}
            />
          ))}
        </ImageSlide>
      </ImageSlider>
    </SectionWrapper>
  );
};

export default ClientBlock;
